import './BasicLayout.scss';

import React, { Fragment } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isEmpty, kebabCase, toLower, uniq } from 'lodash';
import { Router, withRouter } from 'react-router-dom';
import { withAuthState } from '@trp-ta-nitro/auth-react';
import {
  CustomerProvider,
  AuthenticationProvider,
  AccountsProvider,
  EnvironmentIndicator,
  CoreNavigation,
  Stack,
  ThemeProvider,
  ViewProvider
} from '@trp-ii-ii-component-library/ii-components';

import { navTypes } from 'services/globals';
import { getProducts } from 'services/Products';
import { aamLoginUrl, aamLogoutUrl } from 'services/Externals';
import {
  getAccounts,
  mapProductTypeToiiFooterBoolean
} from 'state/account/AccountSelectors';
import { getCustomerForNavigation } from 'state/customer/CustomerSelectors';
import {
  isContextualNavVisible,
  isMainMenuVisible
} from 'state/session/SessionSelectors';
import AAMFooterContainer from './Footer/FooterUtil';
import { isMobile } from '../../state/view/ViewSelectors';

const StackedCoreNavigation = Stack(CoreNavigation);

const BasicLayout = ({
  accounts,
  authState,
  children,
  customer,
  footerProductTypes,
  includedLinks,
  isCustomerWebView = true,
  isMobileApp,
  navType,
  title
}) => {
  const { userId } = authState || {};
  const user = userId ? userId : '';

  // if not logged in, we'll have to handle this differently
  const products = uniq(getProducts(accounts));
  const auth = {
    authorization: {
      isCustomerWebView,
      isAuthenticated: !isEmpty(user)
    },
    loginUrl: aamLoginUrl(products),
    logoutUrl: aamLogoutUrl(),
    user: customer
  };
  return (
    <Fragment>
      <ViewProvider
        accounts={accounts}
        user={user}
        authentication={auth}
        providedRouter={Router}>
        <AuthenticationProvider authentication={auth}>
          <CustomerProvider customer={user}>
            <AccountsProvider accounts={accounts}>
              <ThemeProvider>
                <EnvironmentIndicator
                  customerWebViewEnabled={auth.isCustomerWebView}
                />
                {navType === navTypes.CORE && (
                  <StackedCoreNavigation
                    includedLinks={includedLinks}
                    loginUrl={aamLoginUrl(products)}
                    logoutUrl={aamLogoutUrl()}
                  />
                )}
                <div className="basic-layout-container">
                  <div className="title">{title}</div>
                  <div className={`content-container ${title}-container`}>
                    <div className={`${kebabCase(toLower(title))}-container`}>
                      {children}
                    </div>
                  </div>
                </div>
                <AAMFooterContainer
                  isMobileParam={isMobileApp}
                  footerProductTypes={footerProductTypes}
                  appLoaded={true}
                />
              </ThemeProvider>
            </AccountsProvider>
          </CustomerProvider>
        </AuthenticationProvider>
      </ViewProvider>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    accounts: getAccounts(state),
    footerProductTypes: mapProductTypeToiiFooterBoolean(state),
    customer: getCustomerForNavigation(state),
    isMobileApp: isMobile(state),
    showContextualNav: isContextualNavVisible(state),
    showMainMenu: isMainMenuVisible(state)
  };
};

export default withRouter(
  compose(connect(mapStateToProps), withAuthState)(BasicLayout)
);
